import { Link, useSearchParams } from "react-router";
import { Ansicht } from "../design/Ansicht";
import { Symbol } from "../design/Symbol";
import { useSammlung, type Zeile } from "../plattform/lesemodelle";
import { kanalname } from "./darstellung";
import { Einladungen } from "./Einladungen";

export { kanalname } from "./darstellung";

/**
 * Rahmen einer Ansicht der Drückjagd (Zustandsband, `main` mit Ansichtsnamen; oberflaeche.md §3.2, F-080). Den Rahmen
 * setzt die Route (`App.tsx`), weil Ansichten eines Kontexts keine Ansichten eines anderen importieren.
 */
import type { Rahmen } from "../plattform/rahmen";

export type { Rahmen };

const ARTEN = ["Jagdkanal", "Leitungskanal", "Anstellgruppenkanal", "Treibergruppenkanal", "Jagdherrenkanal"] as const;
const UEBERSCHRIFT: Record<string, string> = { Leitungskanal: "Leitung", Jagdherrenkanal: "Reviere" };
const SYMBOL: Record<string, string> = {
  Jagdkanal: "nachricht", Leitungskanal: "jagdleiter", Anstellgruppenkanal: "ansteller", Treibergruppenkanal: "treiberfuehrer", Jagdherrenkanal: "jagdherr",
};

function sortiert(liste: Zeile[]): Zeile[] {
  return [...liste].sort((a, b) => kanalname(a).localeCompare(kanalname(b), "de"));
}

/**
 * Kanäle (oberflaeche.md §3.1, §7): je Kanal `link` „<Kanalname>“ in einer `region` je Kanalart, davor die Einladungen in
 * Jagdherrenkanäle (V-18). Ab der Startansicht (`?drueckjagd=<id>`) nur die Kanäle dieser Drückjagd, mit Zustandsband.
 */
export function Kanaele({ rahmen }: { rahmen?: Rahmen }) {
  const [suche] = useSearchParams();
  const dj = suche.get("drueckjagd");
  const kanaele = useSammlung("kanaele");
  const liste = dj ? kanaele.daten.filter((k) => k["_drueckjagd"] === dj) : kanaele.daten;
  const ziel = (k: Zeile) => `/kanaele/${k._id}${dj ? `?drueckjagd=${dj}` : ""}`;
  const inhalt = (
    <div className="text-bereich">
      {dj ? null : <Einladungen />}
      {ARTEN.map((art) => {
        const teil = sortiert(liste.filter((k) => k["Kanalart"] === art));
        if (!teil.length) return null;
        return (
          <section key={art} className="liste-bereich" role="region" aria-label={art}>
            <h2 className="kopf"><Symbol name={SYMBOL[art] ?? "nachricht"} />{UEBERSCHRIFT[art] ?? art}</h2>
            {teil.map((k) => (
              <Link key={k._id} to={ziel(k)} className="zeile zeile--knopf platte" aria-label={kanalname(k)}>
                <Symbol name={SYMBOL[art] ?? "nachricht"} />
                <span className="zeile__t">{kanalname(k)}</span>
                <Symbol name="weiter" />
              </Link>
            ))}
          </section>
        );
      })}
      {liste.length === 0 && !kanaele.laedt ? <div className="leer"><Symbol name="nachricht" /><span>Noch kein Kanal</span></div> : null}
    </div>
  );
  if (dj && rahmen) return <>{rahmen({ drueckjagdId: dj, name: "Kanäle", children: inhalt })}</>;
  return <Ansicht name="Kanäle" symbol="nachricht">{inhalt}</Ansicht>;
}
